export const logger = {
  info: (...args: unknown[]): void => {
    console.info('[admin-portal]', ...args);
  },
  error: (...args: unknown[]): void => {
    console.error('[admin-portal]', ...args);
  },
};
